import { render } from "./PageBackground.vue?vue&type=template&id=5b68897e&scoped=true"
import script from "./PageBackground.vue?vue&type=script&lang=js"
export * from "./PageBackground.vue?vue&type=script&lang=js"

import "./PageBackground.vue?vue&type=style&index=0&id=5b68897e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\medrina-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b68897e"]])

export default __exports__